// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/webpack/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-4368214e]{display:none}.menu-button[data-v-4368214e]{--button-width:56px;--button-height:48px;--button-padding:12px 16px;--button-background:var(--c-primary);--button-color:var(--c-white);--button-font-size:24px;--button-border-radius:0 40px 40px 0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
